import { login, getUserInfo } from '@/api/login'
import { getToken, setToken, removeToken, getUser, setUser, removeUser } from '@/utils/auth'
const user = {
  state: {
    token: getToken(),
    userInfo: getUser()
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo
    }
  },

  actions: {
    // 登录
    Login({ dispatch, commit }, userInfo) {
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((res) => {
            setToken('Bearer ' + res.data.access_token)
            commit('SET_TOKEN', 'Bearer ' + res.data.access_token)
            dispatch('GetUserInfo')
            resolve()
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 获取用户信息
    GetUserInfo({ commit, state }, info) {
      return new Promise((resolve, reject) => {
        getUserInfo(info)
          .then((res) => {
            const user = res.data || {}
            setUser(user)
            commit('SET_USERINFO', user)
            resolve(user)
          })
          .catch((error) => {
            reject(error)
          })
      })
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_USERINFO', {})
        removeToken()
        removeUser()
        resolve()
      })
    }
  }
}

export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js